import { MoonIcon, SunIcon } from "@tiendanube/icons";
import classNames from "classnames";
import * as React from "react";
import "./Toggle.scss";

export interface InterfaceToggle {
  onClick: () => void;
  on?: boolean;
}

function Toggle({
  onClick,
  on = false,
}: InterfaceToggle): JSX.Element {
  const className = classNames("nimbus-web--toggle",{"nimbus-web--toggle--inactive": on});

  const toggleIcon = on ? <SunIcon /> : <MoonIcon />;

  return (
    <div className="nimbus-web--toggle-wrapper" onClick={onClick}>
      <div className={className}>{toggleIcon}</div>
    </div>
  );
}

export default Toggle;